import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
	selector: '[trans]'
})
export class TranslateDirective {
	@Input() trans: string;

	constructor(public el: ElementRef) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/i18n/directives/translate.directive.ts